import React from "react";
import swedishImg from "./swedish-massage.jpg";   // ⭐ Correct image import

const SwedishMassage = ({ setActiveSection }) => {
  return (
    <section className="bg-white text-gray-900">

      {/* ⭐ PREMIUM FULL-WIDTH  BANNER */}
      <div className="relative w-full h-[350px] md:h-[450px]">
        <img
          src={swedishImg}
          alt="Swedish Massage Banner"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* ⭐ Center Heading */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg">
            Swedish Massage
          </h1>
        </div>

        {/* ⭐ Left Bottom Title */}
        <div className="absolute bottom-0 left-0 w-full bg-black/40 py-4 px-6">
          <h2 className="text-xl md:text-2xl font-semibold text-white">
            Swedish Massage
          </h2>
        </div>

        {/* ⭐ Right Bottom Breadcrumb */}
        <div className="absolute bottom-0 right-0 bg-black/40 py-4 px-6 flex gap-2 text-white">
          <button
            onClick={() => setActiveSection("home")}
            className="hover:text-amber-300 transition"
          >
            Home
          </button>
          <span>›</span>
          <span className="text-amber-300">Swedish Massage</span>
        </div>
      </div>

      {/* ⭐ MAIN CONTENT */}
      <div className="container mx-auto px-4 py-20 grid md:grid-cols-2 gap-12 items-center">

        {/* LEFT — Image */}
        <div>
          <img
            src={swedishImg}
            alt="Swedish Massage Treatment"
            className="rounded-2xl shadow-2xl w-full h-[500px] object-cover"
          />
        </div>

        {/* RIGHT — Description */}
        <div>
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-amber-900 leading-tight">
            Gentle Healing for Mind & Body Relaxation
          </h2>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            Swedish Massage is known for its calming and rhythmic strokes that
            gently relax the entire body. It reduces stress, improves blood
            circulation, and promotes deep mental relaxation.
          </p>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            This therapy uses long gliding strokes, tapping, kneading, and
            circular motions to ease tension and stimulate natural healing.
          </p>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            Perfect for beginners, office workers, or anyone dealing with
            fatigue, stiffness, and everyday stress. It improves sleep quality
            and leaves your body feeling soft, warm, and refreshed.
          </p>

          <p className="text-gray-700 leading-relaxed mb-5 text-lg">
            Enjoy a peaceful massage session specially designed to relax your
            nerves, soothe your muscles, and bring your mind to a calm state.
          </p>

          {/* BOOK NOW BUTTON */}
          <button
            onClick={() => setActiveSection("booking")}
            className="bg-amber-900 text-white px-12 py-4 rounded-lg text-lg 
                       hover:bg-amber-800 transition-all hover:scale-105 shadow-xl"
          >
            Book Now
          </button>
        </div>

      </div>
    </section>
  );
};

export default SwedishMassage;
